<template>
  <div class="login">
    <div class="login_wrapper">
      <div class="login_form">
        <section class="login_content">
          <h1>{{ $t('loginPage.loginPageName') }}</h1>
          <alert
            :title="$t('loginPage.login')"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="wasTheRequestSuccessful"
            @closeAlert="closeAlert"
          />
          <div class="form-group">
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <label class="control-label" for="userId"
                  >{{ $t('accountManagementPage.userId') }}：</label
                >
              </div>
              <div class="col-md-8 col-xs-12">
                <input
                  id="userId"
                  v-model="userId"
                  v-validate="ValidRules.userId"
                  :data-vv-as="$t('accountManagementPage.userId')"
                  :placeholder="$t('accountManagementPage.userId')"
                  type="text"
                  class="form-control"
                  name="userId"
                />
              </div>
            </div>
            <div
              v-show="validator.has('userId')"
              class="alert alert-danger"
              role="validater"
            >
              <ul>
                <li
                  v-for="(message, index) in validator.collect('userId')"
                  :key="index"
                >
                  {{ message }}
                </li>
              </ul>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <label class="control-label " for="password"
                  >{{ $t('accountManagementPage.password') }}：</label
                >
              </div>
              <div class="col-md-8 col-xs-12">
                <input
                  id="password"
                  v-model="password"
                  v-validate="ValidRules.password"
                  :data-vv-as="$t('accountManagementPage.password')"
                  :placeholder="$t('accountManagementPage.password')"
                  type="password"
                  class="form-control"
                  name="password"
                />
              </div>
            </div>
            <div
              v-show="validator.has('password')"
              class="alert alert-danger"
              role="validater"
            >
              <ul>
                <li
                  v-for="(message, index) in validator.collect('password')"
                  :key="index"
                >
                  {{ message }}
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <button @click="login" class="btn btn-primary submit">
              {{ $t('loginPage.login') }}
            </button>
          </div>
          <div class="separator">
            <h1>{{ $t('loginPage.orderWithTheSmartphone') }}</h1>
            <p>©2016 All Rights Reserved. Epark, inc.</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import ValidRules from '@/validator/LoginRules'
import TokenRequest from '@/http/TokenRequest'

export default {
  components: {
    Alert,
  },
  data() {
    return {
      userId: '',
      password: '',
      ValidRules: ValidRules,
      errors: null,
      alerts: '',
      wasTheRequestSuccessful: false,
    }
  },
  methods: {
    login: function() {
      this.$validator.validate().then((result) => {
        if (result) {
          const request = new TokenRequest()
          const params = {
            userName: this.userId,
            password: this.password,
          }
          request
            .getToken(params)
            .then((res) => {
              this.$store.dispatch('oauth/login', res.data)
              this.$store.dispatch('user/getAuthorities')
              if (this.$route.query.redirect === undefined) {
                this.$router.push({ name: 'home' })
              } else {
                this.$router.push({ path: this.$route.query.redirect })
              }
            })
            .catch((err) => {
              this.errors =
                typeof err.response.data === 'object'
                  ? [err.response.data]
                  : err.response.data
              this.alerts = 'error'
              this.wasTheRequestSuccessful = true
            })
        }
      })
    },
    closeAlert: function() {
      this.wasTheRequestSuccessful = false
    },
  },
}
</script>
<style scoped>
.login {
  height: 100%;
}
.login_content {
  margin: 10px auto;
  max-width: 500px;
}
.login_content h1:before,
.login_content h1:after {
  top: 45px;
}
.login_content h1:after {
  width: 15%;
  background: linear-gradient(to right, #7e7e7e, #fff);
}
.login_content h1:before {
  width: 15%;
  background: linear-gradient(to right, #fff, #7e7e7e);
}
.login_content input[type='text'],
.login_content input[type='email'],
.login_content input[type='password'] {
  border-radius: 3px;
  -ms-box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;
  -o-box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;
  box-shadow: 0 1px 0 #fff, 0 -2px 5px rgba(0, 0, 0, 0.08) inset;
  border: 1px solid #c8c8c8;
  color: #777;
  margin: 0 0 20px;
  width: 100%;
}
.login_content input[type='text']:focus,
.login_content input[type='email']:focus,
.login_content input[type='password']:focus {
  -ms-box-shadow: 0 0 2px #ed1c24 inset;
  -o-box-shadow: 0 0 2px #ed1c24 inset;
  box-shadow: 0 0 2px #a97aad inset;
  background-color: #fff;
  border: 1px solid #a878af;
  outline: none;
}
.login_wrapper {
  max-width: none !important;
}
.login_content >>> .alert,
.alert {
  text-align: left;
  text-shadow: none;
}
</style>
